import { render } from "./KeywordsModalActivities.vue?vue&type=template&id=4db628c0&scoped=true"
import script from "./KeywordsModalActivities.vue?vue&type=script&lang=js"
export * from "./KeywordsModalActivities.vue?vue&type=script&lang=js"

import "./KeywordsModalActivities.vue?vue&type=style&index=0&id=4db628c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db628c0"]])

export default __exports__